"use strict";

exports.__esModule = true;
exports.execIE11ImagePolyfills = void 0;
var execIE11ImagePolyfills = function execIE11ImagePolyfills(ref, objectFitImages) {
  var image = ref.current.querySelector('img');
  if (image) {
    objectFitImages(image);
  }
};
exports.execIE11ImagePolyfills = execIE11ImagePolyfills;